/* import __COLOCATED_TEMPLATE__ from './suggestion-details-panel.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type TaskSuggestion from 'embercom/models/content-service/task-suggestion';
import type { ConversationExploreConversation } from 'embercom/components/reporting/automation/ai-insights/conversation-panel';

interface Signature {
  Args: {
    taskSuggestion: TaskSuggestion;
    suggestedConversationIds: string[];
    onConversationClicked: (conversation: ConversationExploreConversation) => void;
    impactRanking?: number;
    conversationCount?: number;
  };
}

export default class SuggestionDetailsPanel extends Component<Signature> {
  @tracked isConversationsOpen = true;
  @tracked isTopicsOpen = true;

  get topicsIcon() {
    return this.isTopicsOpen ? 'small-thin-down-arrow' : 'small-thin-right-arrow';
  }

  @action
  toggleConversations(): void {
    this.isConversationsOpen = !this.isConversationsOpen;
  }

  @action
  toggleTopics(): void {
    this.isTopicsOpen = !this.isTopicsOpen;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::SuggestionDetailsPanel': typeof SuggestionDetailsPanel;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/suggestion-details-panel': typeof SuggestionDetailsPanel;
  }
}
